import { getFunctions, httpsCallable } from "firebase/functions";

class VoucherService {
    private static instance: VoucherService | null = null;

    public static getInstance(): VoucherService {
        if (this.instance === null) {
            this.instance = new VoucherService();
        }
        return this.instance;
    }

    public async validateAndAssignVoucherAsync(email: string, voucherCode: string, marketingConsent: boolean, recaptchaToken: string): Promise<any | null> {

        var functions = getFunctions();
        const validateAndAssign = httpsCallable(functions, 'validateAndAssignVoucherFunction');
        var productKey = null;
        var response = "";

        await validateAndAssign(
            {
                "userEmail": email,
                "voucherCode": voucherCode,
                "marketingConsent": marketingConsent,
                "recaptchaToken": recaptchaToken,
            })
            .then((result: any) => {
                productKey = result.data['productKey'];
                response = result.data['response'];
            }).catch((error) => {
                productKey = null;
                response = "An error occurred";
            });


        return {
                productKey: productKey,
                response:  response,
            }
    }
}

const useVoucherService = () => {
    return VoucherService.getInstance();
}

export default useVoucherService;

